export default "__VITE_ASSET__d763b542__"